export default {
    uploadCargaARRequestStatus: state => state.uploadCargaARRequestStatus,
    selectedProduct: state => state.selectedProduct,
};